module.exports = __webpack_public_path__ + "img/icon_arrow_right_white.3454e052.svg";